import React from 'react';
import QuoteRequestForm, { BrochureBtn, ImgRender } from '../../BFComponents';

const Intimus45cc3 = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-3">
                    <ImgRender image={"intimus-logo-old.jpg"} cssClass={"my-2"} width={50} normal={true} />
                    <hr className="intimusrule"></hr>
                </div>
            </div>
            <h3>intimus 45 CC3</h3>
            <div className="row">
                <div className="col-md-6 d-flex justify-content-center">
                    <ImgRender image={"45cc3.jpg"} width={75} cssClass={"my-4"} />
                </div>
                <div className="col-md-6 d-flex align-items-center">
                    <div className="align-self-center">
                        The multi functional shredder destroys paper, cds, dvds,
                        floppy disks, staples, paper clips and credit cards. |
                        Integrated Auto Reverse Function for easy removal of
                        jammed paper. | User friendly thanks to i-control® function
                        control. | 2x2 cut & collect: separate cutting blocks for
                        digital media incl. catchbasket. | Silentec®: innovative
                        sound dampening principle and EcoLogic for more energy
                        efficiency
                        <QuoteRequestForm source={window.location} />
                        <BrochureBtn brochure={"Shredder Intimus PRO-45CC3-Brochure.pdf"} />

                    </div>
                </div>

            </div>
            <div id="jumbo32cc" className="p-2">
                <ul>
                    <li>Dustproof enclosed cabinet</li>
                    <li>Mounted on rollers for flexible use</li>
                    <li>Material: shock resistant plastic, wood</li>
                </ul>
            </div>

        </div>
    )
}

export default Intimus45cc3;